import type SessionService from '@efdigital/ll-addon-auth/services/session';
import {
  CANCELLED_KEYS,
  HISTORY_KEYS,
} from '@efdigital/ll-addon-coaching/utils/coaching-sessions/session-lifecycle';
import type { CoachingSession } from '@efdigital/ll-addon-data';
import { queryCoachingSessionsByCoach } from '@efdigital/ll-xceed-v2/data/builders/coaching/coaching-sessions';
import type { CoachingCoachModel } from '@efdigital/ll-xceed-v2/routes/coaching/coach';
import CoachService from '@efdigital/ll-xceed-v2/services/coach';
import { excludeFromLearnerHistory } from '@efdigital/ll-xceed-v2/utils/coaching/session-current-categories';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

export type CoachingCoachSessionsPastModel = CoachingCoachModel & {
  history: CoachingSession[];
};

function sortByStartTimeDesc(sessions: CoachingSession[]): CoachingSession[] {
  return [...sessions].sort(
    (left, right) => Date.parse(right.startTime) - Date.parse(left.startTime)
  );
}

export default class CoachingCoachSessionsPastRoute extends Route<CoachingCoachSessionsPastModel> {
  @service declare coach: CoachService;
  @service declare store: Store;
  @service declare session: SessionService;

  async model(): Promise<CoachingCoachSessionsPastModel> {
    const coachModel = this.modelFor('coaching.coach') as CoachingCoachModel;
    const coachUserId = this.session.cached.userId!;

    const [cancelledSessions, historySessions] = await Promise.all([
      this.store.request(
        queryCoachingSessionsByCoach(coachUserId, CANCELLED_KEYS)
      ),
      this.store.request(
        queryCoachingSessionsByCoach(coachUserId, HISTORY_KEYS)
      ),
    ]);

    const cancelled = cancelledSessions.content.data;
    const delivered = historySessions.content.data.filter((session) =>
      excludeFromLearnerHistory(session, 'coach')
    );
    const history = sortByStartTimeDesc([...cancelled, ...delivered]);

    return {
      ...coachModel,
      history,
    };
  }
}
